export default "__VITE_ASSET__DuS3a0$0__"